module.exports = __webpack_public_path__ + "img/toggle-off.71380be6.svg";